import React, { useState, useEffect } from 'react';
import { Modal, message } from 'antd';
import { MoreOutlined } from '@ant-design/icons';
import httpInjectorService from 'services/http-injector.service';
import { Popconfirm } from 'antd';
import UserAvatar from 'components/userAvatar';
import { toast } from 'react-toastify';
import { ThunderboltOutlined } from '@ant-design/icons';
import SubtaskObject from '@atlaskit/object/subtask';
import TaskObject from '@atlaskit/object/task';
import StoryObject from '@atlaskit/object/story';
import BugObject from '@atlaskit/object/bug';

const ListLinkedWorkItems = ({ item_id, item_type,refreshFlag }) => {
 
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [openMenuId, setOpenMenuId] = useState(null);
  const [hoveredRow, setHoveredRow] = useState(null);
  const [workItems, setWorkItems] = useState(null);

  const getStatusColor = (status) => {
    switch (status) {
      case 'IN PROGRESS':
        return '#3b82f6';
      case 'TO DO':
        return '#9ca3af';
      case 'DONE':
        return '#22c55e';
      default:
        return '#6b7280';
    }
  };

  const handleUnlink = async (item) => {
    try {
      await httpInjectorService.delete(`/unlink/${item.id}`);
      message.success('Unlinked');
    } catch (e) {
      message.error('Failed');
    }
  };

  const getLinkedWorkItems = async () => {
    let reqbody = {
      item_type: item_type,
      item_id: item_id,
    };
    try {
      let response = await httpInjectorService.getLinkedWorkItems(reqbody);
      if (response.status === 'success') {
        setWorkItems(response.data);
      } else {
        setWorkItems({});
      }
    } catch (e) {
      throw e;
    }
  };

  useEffect(() => {
    
    getLinkedWorkItems();
  }, [refreshFlag]);

  const showModal = (id) => {
   
    setSelectedId(id);
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setSelectedId(null);
  };

  const handleOk = async (item) => {
   
    try {
      setLoading(true);
      let response = await httpInjectorService.deletelinkType(item.link_id);
      if (response.status === 'success') {
        toast.success(response.message, { autoClose: 3000 });
        getLinkedWorkItems();
      } else {
        toast.error(response.message, { autoClose: 3000 });
      }
    } catch (err) {
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const getIcon = (item) => {
    if (item.item_type === 'epic') {
      return <ThunderboltOutlined style={{ color: '#6554C0', fontSize: 16 }} />;
    }

    if (item.item_type === 'subtask') {
      return <SubtaskObject />;
    }

    if (item.issue_type_id === 1) {
      return <TaskObject />;
    }

    if (item.issue_type_id === 2) {
      return <StoryObject />;
    }

    if (item.issue_type_id === 3) {
      return <BugObject />;
    }

    return null;
  };

  // Close menu on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!e.target.closest('.menu-container')) {
        setOpenMenuId(null);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);

  return (
    <div>
      {Object.entries(workItems || {}).map(([section, items]) => (
        <div key={section} style={{ marginBottom: '16px' }}>
          {/* Section Title */}
          <div
            style={{
              color: '#6b7280',
              fontSize: '13px',
              marginBottom: '6px',
              fontWeight: '600',
              textTransform: 'uppercase',
            }}
          >
            {section}
          </div>

          {/* Items */}
          {items.map((item, index) => {
            const rowKey = `${item.link_id}-${item.item_id}`;

            return (
              <div
                key={rowKey}
                onMouseEnter={() => setHoveredRow(rowKey)}
                onMouseLeave={() => setHoveredRow(null)}
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  padding: '10px',
                  borderBottom:
                    index !== items.length - 1 ? '1px solid #e5e7eb' : 'none',
                }}
              >
                {/* LEFT */}
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                    color: '#111827',
                  }}
                >
                  <span style={{ display: 'flex', alignItems: 'center' }}>
                    {getIcon(item)}
                  </span>
                  <span style={{ color: '#6b7280' }}>{item.key}</span>
                  <span>{item.title}</span>
                </div>

                {/* RIGHT */}
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                  }}
                >
                  {/* Status */}
                  <div
                    style={{
                      background: '#e5e7eb',
                      padding: '2px 8px',
                      borderRadius: '4px',
                      fontSize: '12px',
                    }}
                  >
                    {item.status}
                  </div>

                  {/* Avatar */}
                  <UserAvatar
                    username={item.assignee || 'Unassigned'}
                    size={20}
                  />

                  {/* ❌ Unlink */}
                  <span
                    title="Unlink work item"
                    onClick={() => handleOk(item)}
                    style={{
                      cursor: 'pointer',
                      fontSize: '14px',
                      color: hoveredRow === rowKey ? '#ef4444' : 'transparent',
                      background:
                        hoveredRow === rowKey ? '#fee2e2' : 'transparent',
                      borderRadius: '50%',
                      width: '20px',
                      height: '20px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      transition: '0.2s',
                    }}
                  >
                    ✕
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      ))}
    </div>
  );
};

export default ListLinkedWorkItems;
